// extracted by mini-css-extract-plugin
module.exports = {"popular-jobs":"popular-jobs_popular-jobs__ngX8l","compact":"popular-jobs_compact__M7QJN","wide":"popular-jobs_wide__dqgc2"};